// src/hooks/usePageView.ts

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    analytics?: {
      page: (path: string) => void;
    };
  }
}

export function usePageView(): void {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.analytics) window.analytics.page(location.pathname);
  }, [location]);
}
